import { Box, Card, Input, Typography } from "@mui/joy";
import { WandSparkles, FolderPlus, FileBarChart, ListChecks, Truck } from "lucide-react";

export default function Assistance() {
    return (
        <Card variant="soft" sx={{ height: "50%", background: "#29693a21" }}>
            <Box display={"flex"} flexDirection={"column"} justifyContent={"space-between"} height={"100%"}>
                <Box>
                    <Typography>Hi, Nithin</Typography>
                    <Typography level="title-lg">How can I help you?</Typography>
                </Box>

                <Box flex={1} display={"flex"} flexDirection={"column"} gap={1} mt={4} mb={2}>
                    <Box display={"flex"} gap={1} flex={1}>
                        <Card
                            sx={{
                                flex: 1,
                                display: "flex",
                                alignItems: "left",
                                gap: 1,
                                p: 2,
                                justifyContent: "center",
                            }}
                        >
                            <FolderPlus size={18} />
                            <Typography level="body-md">Create Project</Typography>
                        </Card>
                        <Card
                            sx={{
                                flex: 1,
                                display: "flex",
                                alignItems: "left",
                                gap: 1,
                                p: 2,
                                justifyContent: "center",
                            }}
                        >
                            <FileBarChart size={18} />
                            <Typography level="body-md">View Reports</Typography>
                        </Card>
                    </Box>
                    <Box display={"flex"} gap={1} flex={1}>
                        <Card
                            sx={{
                                flex: 1,
                                display: "flex",
                                alignItems: "left",
                                gap: 1,
                                p: 2,
                                justifyContent: "center",
                            }}
                        >
                            <ListChecks size={18} />
                            <Typography level="body-md">Manage Tasks</Typography>
                        </Card>
                        <Card
                            sx={{
                                flex: 1,
                                display: "flex",
                                alignItems: "left",
                                gap: 1,
                                p: 2,
                                justifyContent: "center",
                            }}
                        >
                            <Truck size={18} />
                            <Typography level="body-md">Track Suppliers</Typography>
                        </Card>
                    </Box>
                </Box>

                <Input
                    placeholder="Ask something"
                    sx={{ mt: 2, borderRadius: 30, py: 1.5 }}
                    endDecorator={<WandSparkles size={16} />}
                />
            </Box>
        </Card>
    );
}
